import type { NodeAction } from "../schemas/index.ts";

export class InvalidActionError extends Error {
  name = "InvalidActionError";
  readonly action: NodeAction;

  constructor(action: NodeAction, ...params: Parameters<typeof Error>) {
    super(...params);
    this.action = action;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, InvalidActionError);
    }
  }
}
